import { Outlet } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Root() {
  return (
    <div className="relative min-h-screen pb-44">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}
